import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=1e585408&"
import script from "./RelatedArticles.vue?vue&type=script&lang=js&"
export * from "./RelatedArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports